import React, { useEffect, useState } from "react";
import CommonForm from "../../components/common/CommonForm"; // Assurez-vous que le chemin est correct
import { PlusIcon } from "@heroicons/react/24/solid";
import { useDispatch } from "react-redux";
import { addPlat, editPlat, getAllPlats } from "../../store/platSlice";

const PlatForm = ({ platFormControls, formTitle, isDataEdit, isLigneProduit, produitOptions, setIsModalOpen, onPlatUpdated }) => {

    const initialState = {
        designation: "",
        nbPortion: 0,// Nombre de portions de ce plat
        alertPortion: 0,// minimum de portions de ce plat avant alert
        prixVente: 0,// Prix de vente de chaque portion
        tauxTVA: 1,// Taux de TVA
        tempsPrepa: "",// Temps nécessaire pour préparer le plat
        prixTotalRevient: 0,// Prix de revient du plat : somme des prix de revient de ses produits
        prixUnitaire: 0,// Prix de revient unitaire par portion : prixTotalRevient / nbPortion
        pourcentageInvendu: 0,// Pourcentage d'invendu du plat 
        prixRUV: 0,// Prix de Revient Unitaire par portion Vendu : prixUinitaire +  (prixUnitaire * pourcentageInvendu)
        prixVUHT: 0,// Prix de Vente Unitaire Hors Taxe : prixVente / (1 + tauxTVA)
        margeBrute: 0,// Marge Brute par portion vendu : prixVUHT - prixRUV
        description: "",// Nom du plat
        categorieid: "",
    }

    const [platData, setPlatData] = useState(initialState || isDataEdit);

    const [ligneProduits, setLigneProduits] = useState([]);

    const [listProduitsOptions, setListProduitsOptions] = useState([]);


    const dispatch = useDispatch();

    useEffect(() => {
        if (isDataEdit) {
            setPlatData({
                ...isDataEdit,
                prixTotalRevient: parseFloat(isDataEdit.prixTotalRevient),
                prixUnitaire: parseFloat(isDataEdit.prixUnitaire),
                prixRUV: parseFloat(isDataEdit.prixRUV),
                prixVUHT: parseFloat(isDataEdit.prixVUHT),
                margeBrute: parseFloat(isDataEdit.margeBrute),
            });
            setLigneProduits(
                isLigneProduit.map((l) => ({
                    ...l,
                    ProduitId: l.ProduitId.toString(),
                }))
            );

        }

        setListProduitsOptions(
            produitOptions
                .filter((produit) =>
                    produit.designation.startsWith("Cuisine")
                )
        );

    }, [isDataEdit, isLigneProduit]);



    useEffect(() => {
        const prixTotalRevient = ligneProduits.reduce(
            (total, ligne) => total + parseFloat(ligne.prixRevient || 0),
            0
        );

        if (platData.nbPortion > 0) {
            const nbPortion = parseFloat(platData.nbPortion || 1);
            const pourcentageInvendu = parseFloat(platData.pourcentageInvendu || 0) / 100;
            const tauxTVA = parseFloat(platData.tauxTVA || 1) / 100;
            const prixVente = parseFloat(platData.prixVente || 0);

            const prixUnitaire = prixTotalRevient / nbPortion;
            const prixRUV = prixUnitaire + prixUnitaire * pourcentageInvendu;
            const prixVUHT = prixVente - (prixVente * tauxTVA);
            const margeBrute = prixVUHT - prixRUV;

            setPlatData((prevData) => ({
                ...prevData,
                prixTotalRevient,
                prixUnitaire,
                prixRUV,
                prixVUHT,
                margeBrute,
            }));
        }

    }, [ligneProduits, platData.nbPortion, platData.pourcentageInvendu, platData.tauxTVA, platData.prixVente]);


    // Ajouter une nouvelle ligne dans le tableau
    const addLigneProduit = () => {
        setLigneProduits([
            ...ligneProduits,
            { ProduitId: "", uniteNecessaire: "", prixRevient: "" },
        ]);
    };

    // Supprimer une ligne du tableau
    const removeLigneProduit = (index) => {
        const updatedLignes = ligneProduits.filter((_, i) => i !== index);
        setLigneProduits(updatedLignes);
    };

    // Mettre à jour les valeurs d'une ligne
    const handleLigneProduitChange = (index, e) => {
        const { name, value } = e.target;

        setLigneProduits((prevLignes) => {
            const updatedLignes = [...prevLignes];

            if (name === "uniteNecessaire") {
                const uniteNecessaire = value === "" ? "" : parseFloat(value);
                updatedLignes[index][name] = uniteNecessaire;

                // Vérifie si uniteNecessaire est supérieur à 0 pour calculer le prix
                if (uniteNecessaire > 0) {
                    const produitId = parseInt(updatedLignes[index].ProduitId, 10);
                    const produit = produitOptions.find((p) => p.id === produitId);
                    const prixProduit = produit ? parseFloat(produit.prix) : 0;

                    updatedLignes[index].prixRevient = uniteNecessaire * prixProduit;
                } else {
                    updatedLignes[index].prixRevient = 0; // Prix revient à 0 si uniteNecessaire <= 0
                }
            } else {
                updatedLignes[index][name] = value;
            }

            return updatedLignes;
        });

        /*
        setLigneProduits((prevLignes) => {
            const updatedLignes = [...prevLignes];

            updatedLignes[index][name] = value;

            if (name === "uniteNecessaire" || name === "ProduitId") {
                // Convertir ProduitId en entier pour correspondre aux ids de produitOptions
                const produitId = parseInt(updatedLignes[index].ProduitId, 10);
                const produit = produitOptions.find((p) => p.id === produitId);

                // Si uniteNecessaire est vide, définir par défaut à 1
                const uniteNecessaire = parseFloat(updatedLignes[index].uniteNecessaire || 0);

                // Si produit est trouvé, récupérer son prix, sinon mettre 0
                const prixProduit = produit ? parseFloat(produit.prix) : 0;

                // Calculer le prix de revient
                updatedLignes[index].prixRevient = uniteNecessaire * prixProduit;
            }

            return updatedLignes;
        }); */

    };

    const validateForm = () => {
        if (platData.designation === "") return "Veuillez Saisir la désignation.";
        if (platData.nbPortion <= 0) return "Merci de saisir le nombre de portions.";
        if (platData.alertPortion <= 0) return "Veuillez quantié de portions avant alert.";
        if (platData.prixVente <= 0) return "Merci de saisir le prix de vente.";
        if (platData.pourcentageInvendu <= 0) return "Le pourcentage d'invendu doit être supérieur à zéro.";
        if (platData.tempsPrepa === "") return "Veuillez choisir le temps de preparation.";
        if (platData.tauxTVA <= 0) return "Veuillez choisir le taux de charge de TVA.";
        if (platData.categorieid === "") return "Veuillez choisir une categorie.";
        if (ligneProduits.length === 0) return "Veuillez ajouter au moins une ligne de produit.";
        return null;
    };

    // Soumission du formulaire
    const handleSubmit = (e) => {
        e.preventDefault();

        const errorMessage = validateForm();
        if (errorMessage) {
            alert(errorMessage); // Remplacez par un meilleur système de gestion des erreurs
            return;
        }

        isDataEdit !== null
            ? dispatch(
                editPlat({
                    platId: isDataEdit.id,
                    platData,
                    ligneProduits,
                })
            ).then((data) => {
                if (data?.payload?.success) {
                    dispatch(getAllPlats());
                    setPlatData({});
                    setIsModalOpen(false); // Ferme le modal après la soumission
                    const updatedPlat = data?.payload?.data;
                    onPlatUpdated && onPlatUpdated(updatedPlat);
                }
            })
            : dispatch(
                addPlat({
                    platData,
                    ligneProduits
                })
            ).then((data) => {
                if (data?.payload?.success) {
                    dispatch(getAllPlats());
                    setPlatData(initialState);
                    setIsModalOpen(false); // Ferme le modal après la soumission
                }
            });

        setIsModalOpen(false);

        // Mettre à jour les données du plat

        // console.log("Données du plat :", platData);
        // console.log("Produits associés :", ligneProduits);
        // Envoyer les données au backend ici
    };




    return (
        <div className="p-4 max-h-[90vh] overflow-y-scroll">
            <table className="mb-3 w-full">
                <tr>
                    <td>P.T.R : {platData.prixTotalRevient.toFixed(2) || 0} |</td>
                    <td>P.R.U.V : {platData.prixRUV.toFixed(2)} |</td>
                    <td>P.U.P : {platData.prixUnitaire.toFixed(2)} |</td>
                    <td>P.V.U.H.T : {platData.prixVUHT.toFixed(2)} |</td>
                    <td className={` ${platData.margeBrute < 0 ? "text-red-500" : "text-green-500"}`}>M.B : {platData.margeBrute.toFixed(2)}</td>
                </tr>
            </table>
            <CommonForm
                formControls={platFormControls}
                formData={platData}
                formTitle={formTitle}
                setFormData={setPlatData}
                handleSubmit={handleSubmit}
                ButtonText="Soumettre"
            />

            <div className="flex justify-between items-center mb-2 px-6 pt-6">
                {/* Contenu côté gauche */}
                <div className="flex items-center space-x-2">
                    <span>Ajout produit</span>
                    <PlusIcon
                        className="w-8 h-8 text-teal-400 cursor-pointer"
                        onClick={addLigneProduit}
                    />
                </div>
            </div>

            <table className="border-collapse border-gray-300 mt-4 border w-full">
                <thead>
                    <tr className="bg-gray-100">
                        <th className="border-gray-300 px-2 border">Produit</th>
                        <th className="border-gray-300 px-2 border">Unité nécessaire</th>
                        <th className="border-gray-300 px-2 border">Prix de revient</th>
                        <th className="border-gray-300 px-2 border">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {ligneProduits.map((ligne, index) => (
                        <tr key={index} className="hover:bg-gray-100">
                            <td className="border-gray-300 px-2">
                                <select
                                    name="ProduitId"
                                    value={ligne.ProduitId}
                                    onChange={(e) => handleLigneProduitChange(index, e)}
                                    className="px-2 border rounded w-full"
                                >
                                    <option value="">Choisir un produit</option>
                                    {listProduitsOptions.map((option) => (
                                        <option key={option.id} value={option.id}>
                                            {option.designation}
                                        </option>
                                    ))}
                                </select>
                            </td>
                            <td className="border-gray-300 px-2">
                                <input
                                    type="number"
                                    step="0.001"
                                    name="uniteNecessaire"
                                    value={ligne.uniteNecessaire}
                                    onChange={(e) => handleLigneProduitChange(index, e)}
                                    className="px-2 border rounded w-full"
                                />
                            </td>
                            <td className="border-gray-300 px-2">
                                <input
                                    type="number"
                                    name="prixRevient"
                                    value={ligne.prixRevient}
                                    readOnly
                                    className="px-2 border rounded w-full"
                                />
                            </td>
                            <td className="border-gray-300 px-2 text-center">
                                <button
                                    type="button"
                                    onClick={() => removeLigneProduit(index)}
                                    className="font-bold text-red-500"
                                >
                                    Supprimer
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default PlatForm;
